module.exports = __webpack_public_path__ + "img/special-event_cn.cc0292f.jpg";